import {Availability, ResultDocument} from '../../../../commons/types/SearchResult'

export const getAvailability = (resultDocument: ResultDocument): Availability => {
  return resultDocument.availability || 'PREMIUM'
}
